// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeAnalytics, Analytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBokNLNIf99phf_GniwbGzdxAxT8Y47Sgg",
  authDomain: "tours-app-1579553856346.firebaseapp.com",
  databaseURL: "https://tours-app-1579553856346.firebaseio.com",
  projectId: "tours-app-1579553856346",
  storageBucket: "tours-app-1579553856346.appspot.com",
  messagingSenderId: "613221148836",
  appId: "1:613221148836:web:c9cbad89095f79bdf69e31",
  measurementId: "G-J9J9CHPYRN"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Analytics with debug mode for DebugView
export const analytics: Analytics = initializeAnalytics(app, {
  config: { debug_mode: true },
});
